import { BrowserModule } from '@angular/platform-browser';
import { NgModule } from '@angular/core';
import { CommonModule } from '@angular/common';

import { AppRoutingModule } from './app-routing.module';
import { AppComponent } from './app.component';
import { ContentModule } from './pages/blog/content/content.module';
import { FormModule } from './pages/form/form.module';
import { provideHttpClient, withInterceptorsFromDi, withXhr } from '@angular/common/http';
import { AdaptersModule } from './adapters/adapters.module';
import { CoreModule } from './core/core.module';
import { httpInterceptorProviders } from './core/http-interceptors';
//import { LoggerModule, NGXLogger } from 'ngx-logger';
import { environment } from 'src/environments/environment';
import { RECAPTCHA_V3_SITE_KEY, RecaptchaV3Module } from 'ng-recaptcha-2';
import { BrowserAnimationsModule } from '@angular/platform-browser/animations';
import { LineModule } from './register/line/line.module';
import { SharedModule } from './shared/shared.module';
import { AddLineTiscoComponent } from './pages/add-line-tisco/add-line-tisco.component';
import { SeoService } from './adapters/seo.service';
import { TermsAndConditionComponent } from './pages/terms-and-condition/terms-and-condition.component';
import {DealerModule} from './claim/dealer/dealer.module'
import { RenewalModule } from './renewal/renewal.module';

@NgModule({ declarations: [AppComponent, AddLineTiscoComponent, TermsAndConditionComponent],
    bootstrap: [AppComponent], imports: [BrowserModule,
        AppRoutingModule,
        ContentModule,
        FormModule,
        AdaptersModule,
        CoreModule,
        // LoggerModule.forRoot({
        //     ...environment.logger,
        //     httpResponseType: 'json'
        // }),
        RecaptchaV3Module,
        BrowserAnimationsModule,
        LineModule,
        SharedModule,
        RenewalModule
    ], providers: [
        httpInterceptorProviders,
        //NGXLogger,
        { provide: RECAPTCHA_V3_SITE_KEY, useValue: environment.siteKey },
        // { provide: 'googleTagManagerId',  useValue: environment.google_tage_analytic_config },
        SeoService,
        provideHttpClient(withXhr(), withInterceptorsFromDi())
    ] })
export class AppModule { }
